import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {    
    async register(email, fname, lname, recaptchaResponse) {
        try
        {           
            //register by email 
            var data = {
                email: email
                ,firstName: fname
                ,lastName: lname
                ,recaptchaResponse: recaptchaResponse
            }
           
            const response = await axios.post(`Registration/register`, {
                userItem: data
            });          

            return response;
        }
        catch (error)
        {
            console.log('axios register error: ' + error)
            //return '409' //todo
            throw error
        }
    },
    async addmember(data) {
        try
        {            
            const response = await axios.post(`Registration/addmember`, {
                userItem: data
            },
            {
                headers: {
                    'page_key': pageKeys.employees
                }
            })
            return response;
        }
        catch (error)
        {
            throw error
        }
    },
    async verify(recaptchaResponse, code) {
        try
        {   
            var data = {
                recaptchaResponse: recaptchaResponse
            }

            const response = await axios.post(`Registration/verify/${code}`, {
                userItem: data
            });
            return response;
        }
        catch (error)
        {     
            throw error
        }
    },
    async addLinkedAccount(data) {
        try {            
            const response = await axios.post(`Registration/add-linked-account`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_linked_account
                }
            })
            return response;
        }catch (error){
            throw error
        }
    },
}